var _style, _path, _path2, _script;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAkash = function SvgAkash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "akash_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 30.4 26.6",
    style: {
      enableBackground: "new 0 0 30.4 26.6"
    },
    xmlSpace: "preserve",
    role: "img"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".akash_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#ed3524}")), /*#__PURE__*/React.createElement("g", {
    id: "akash_svg__Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akash_svg__R15_Mobile_Home",
    transform: "translate(-172 -62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akash_svg__Top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akash_svg__Group-20",
    transform: "translate(17 61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akash_svg__akash-logo",
    transform: "translate(155 1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "akash_svg__Fill-11",
    className: "akash_svg__st0",
    d: "m9.9 0 15.4 26.6 5.1-8.9L20.1 0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "akash_svg__Fill-12",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ae1e23"
    },
    d: "m9.9 18.2 5.3 8.4h10.6l-5.3-8.4z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "akash_svg__Fill-13",
    className: "akash_svg__st0",
    d: "M5.3 8.4 0 17.5l5.3 9.1L16 8.4z"
  }))))))), _script || (_script = /*#__PURE__*/React.createElement("script", null)));
};
export default SvgAkash;